/**
 * default mode
 * @type {string}
 */
exports.currentMode = 'edit_mode';

/**
 * whether the request to replace a character
 * @type {boolean}
 */
exports.replaceRequest = false;

/**
 * whether the request to paste characters in new line
 * @type {boolean}
 */
exports.pasteInNewLineRequest = false;

/**
 * the starting position of selected text (visual mode)
 * @type {undefined}
 */
exports.visualPosition = undefined;

/**
 * the end position of selected text (visual mode)
 * @type {undefined}
 */
exports.visualCursor = undefined;


/*****************
 ** WEBPACK FOOTER
 ** ./src/instance/vim/init.js
 ** module id = 4
 ** module chunks = 0
 **/